export default "__VITE_ASSET__bFJ1Qogx__"